import { Realizado } from './realizado';
import { Semestre } from './semestre';

/** Dados de um ano para os KPI's de produtividade */
export class Ano {
    ano: number;
    semestres: Semestre[];
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<Ano>) {
        Object.assign(this, props);
        // Semestres
        this.constructorSemestres(props?.semestres ?? []);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /** Constructor para os semestres */
    private constructorSemestres(semestres: Semestre[]) {
        if (semestres && Array.isArray(semestres)) {
            this.semestres = semestres.map(semestre => new Semestre(semestre));
        } else {
            this.semestres = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Ano {
        return new Ano(JSON.parse(json));
    }
}
